// import gameService from "@/services/game.service";
import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    isAppLoading: false,
  }),
  getters: {},
  actions: {
    setAppLoader(isLoading) {
      this.isAppLoading = isLoading;
    },
    showAppLoader() {
      this.isAppLoading = true;
    },
    hideAppLoader() {
      this.isAppLoading = false;
    },
  },
});
